"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = require("./context");
exports.LocaldataContext = context_1.LocaldataContext;
exports.LocaldataProvider = context_1.LocaldataProvider;
exports.Localdata = context_1.Localdata;
